export default __webpack_public_path__ + "static/media/Manual-4.7083c1e2.png";